import { HttpContextToken, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from '../services/user.service';

// Opt a specific request out of the global "401 -> force logout" behavior
// below. Use for non-critical, best-effort calls (e.g. an entitlement check
// run on every page load) where a failure should degrade quietly instead of
// ending the user's whole session.
export const SKIP_AUTH_ERROR_LOGOUT = new HttpContextToken<boolean>(() => false);

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {

  private isRedirecting = false;

  constructor(private userService: UserService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse && err.status === 401 && !this.isRedirecting
          && !req.context.get(SKIP_AUTH_ERROR_LOGOUT)) {
          this.isRedirecting = true;
          this.userService.clearStorageData('/login');
        }
        return throwError(() => err);
      })
    );
  }
}
